import React, {useMemo, useState} from 'react';
import {TaskListWrapper} from '../../../../my-work-tab/my-tasks-page/MyWork.styled';
import TaskRow from './Task_row';
import TaskListHeader from './Task_row_header';
import Util from '../../../util/util';
import {isNovaInvocationEnabled} from '../../nova-invocation/novaInvocationGate';
import {shouldShowNovaColumn} from '../../nova-invocation/novaColumnPresence';

export const TaskList = ({
	intl,
	enabledColumns,
	tasks,
	history,
	viewer,
	enableSort,
	stickyTopPosition,
	isInContainer,
	localSortKey,
	cy,
	showNovaColumn: showNovaColumnOverride,
}) => {
	const [sortBy, setSortBy] = useState(
		localSortKey && Util.localStorageGetItem(localSortKey)
			? JSON.parse(Util.localStorageGetItem(localSortKey))
			: {column: null, ascending: false}
	);
	Util.sortTasks(tasks, sortBy);

	const setSorting = sortBy => {
		if (enableSort) {
			setSortBy(sortBy);
			if (localSortKey) {
				Util.localStorageSetItem(localSortKey, JSON.stringify(sortBy));
			}
		}
	};

	// Computed once here, not independently by the header and each row, so the two can never
	// disagree on whether the Nova column's width is reserved (a header/row width mismatch
	// misaligns every column after it).
	//
	// The override a caller passes wins, and is load-bearing again: for somebody who cannot act the
	// column depends on whether any task has an answer to read, so sibling lists over one task set
	// have to be told the answer centrally or they decide from their own slice, disagree, and
	// misalign against each other. A list with no override still decides for itself, which is
	// right for a caller that renders only one.
	const computedShowNovaColumn = useMemo(
		() => isNovaInvocationEnabled() && enabledColumns?.nova !== false && shouldShowNovaColumn(tasks),
		[enabledColumns, tasks]
	);
	const showNovaColumn = showNovaColumnOverride !== undefined ? showNovaColumnOverride : computedShowNovaColumn;

	return (
		<TaskListWrapper>
			<TaskListHeader
				intl={intl}
				enabledColumns={enabledColumns}
				sortBy={sortBy}
				onSortByChange={enableSort ? sortBy => setSorting(sortBy) : null}
				stickyTopPosition={stickyTopPosition}
				isInContainer={isInContainer}
				showNovaColumn={showNovaColumn}
			/>
			{tasks.map(task => (
				<TaskRow
					cy={cy}
					key={task.node.id}
					intl={intl}
					task={task.node}
					enabledColumns={enabledColumns}
					showTaskModal={taskId => Util.showTaskModal(taskId, history)}
					viewer={viewer} //TODO to removed, only used for Generic task context menu
					showNovaColumn={showNovaColumn}
				/>
			))}
		</TaskListWrapper>
	);
};
